import {defineStore} from 'pinia'
import {type PopupNs} from "@shared/types";

export const useGeneralStore = defineStore("general", {
    state: () => ({
        isLoading: false,
        popup: {} as PopupNs.Popup,
    }),
    getters: {
        getIsLoading: (state) => state.isLoading,
        getPopup: (state): PopupNs.Popup => state.popup,
    },
    actions: {
        setLoading(payload: boolean): void {
            this.isLoading = payload
        },


        showPopup(payload: PopupNs.Popup): void {
            payload.isOpen = true;
            if (!payload.static) {
                payload.static = true;
            }
            this.popup = payload
        },
        closePopup(): void {
            this.popup.isOpen = false
        },
    }
});
